<template>
  <section class="news">
    <div class="news-list">
      <home-news-item :article="news[page * 2]"></home-news-item>
      <home-news-item :article="news[page * 2 + 1]"></home-news-item>
    </div>
    <span class="news-list__prev icon-arrow-left-green" v-on:click="changeNewsPage(-1)" v-if="page>0"></span>
    <span class="news-list__next icon-arrow-right-green" v-on:click="changeNewsPage(1)" v-if="page<(news.length/2)-1"></span>
  </section>
</template>

<script>
import HomeNewsItem from "./HomeNewsItem";
import HomeNewsAd from "./HomeNewsAd";
import { changeNewsPage } from "./HomeActions";

export default {
  vuex: {
    getters: {
      news: state => state.news,
      page: state => state.newsPage
    },
    actions: { changeNewsPage }
  },
  components: { HomeNewsItem, HomeNewsAd }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .news{
    max-width: 1120px;
    margin: 100px auto;
    position: relative;
  }

  .news-list{
    @include row(30px);
    padding: 0;
    margin-top: 0px;
    margin-bottom: 30px;
    overflow: hidden;

    &__prev, &__next{
      display: block;
      width: 30px;
      height: 20px;
      position: absolute;
      top: 200px;
      cursor: pointer;
    }

    &__prev{
      left: -80px;
    }

    &__next{
      right: -80px;
    }
  }
</style>



// WEBPACK FOOTER //
// HomeNews.vue?68f1fc12